export default "__VITE_ASSET__BJTXLotY__"